import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import React, { useState } from "react"
import Dialog from "@material-ui/core/Dialog"
import QuantityButton from "src/features/QuantityButton"

function MyModal({ children, onConfirm, defaultQty }) {
  const [quantity, setQuantity] = useState(defaultQty || 1)
  const handleChange = (val) => {
    setQuantity(val)
  }

  const [open, setOpen] = useState(false)
  const handleToggle = () => {
    setOpen(!open)
  }

  const handleConfirm = () => {
    onConfirm(quantity)
    setOpen(!open)
  }

  return (
    <>
      {React.cloneElement(children, { onClick: handleToggle })}
      <Dialog maxWidth="xs" fullWidth open={open} onClose={handleToggle}>
        <Box p={3}>
          <Box fontWeight="bold" mb={3}>
            เลือกจำนวน
          </Box>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <QuantityButton
              minValue={1}
              value={quantity}
              onChange={handleChange}
            />
          </Box>
          <Box display="flex" mt={3}>
            <Box mr={1} ml="auto">
              <Button
                disableElevation
                variant="contained"
                onClick={handleToggle}
              >
                กลับ
              </Button>
            </Box>
            <Button
              disableElevation
              variant="contained"
              color="primary"
              onClick={handleConfirm}
            >
              ตกลง
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  )
}

export default MyModal
